import { DataTableColumnHeader } from "@components/ui/data-table/DataTableColumnHeader";
import { createColumn } from "@/lib/table/columnFactory";
import { TicketCategoryBadge } from "../components/shared/TicketCategoryBadge";
import type { Ticket, TicketColumnSettings } from "./types";

export const categoryColumnFactory = (settings: TicketColumnSettings) =>
  createColumn<Ticket>({
    id: "category",
    accessorKey: "category",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Catégorie" />,
    cell: ({ row }) => (
      <TicketCategoryBadge category={row.original.category} size={settings.badgeSize} />
    ),
    size: settings.colWidth.badge,
  });
